import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ModalData } from '../model-data';
import { ButtonsDialog, TypeDialog } from '../model-type';

@Component({
  selector: 'app-my-modal',
  templateUrl: './my-modal.component.html',
  styleUrls: ['./my-modal.component.css']
})

export class MyModalComponent implements OnInit {

  buttonsOk = false;
  buttonsOkCancel = false;
  buttonsOkNoCancel = false;
  buttonsCancel = false;


  typeSuccess = false;
  typeWarn = false;
  typeConfirm = false;
  typeInformation = false;

  constructor(
    public dialogRef: MatDialogRef<MyModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData) {

    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    if (this.data.buttons === ButtonsDialog.ok) {
        this.buttonsOk = true;
    } else if (this.data.buttons === ButtonsDialog.okcancel) {
        this.buttonsOkCancel = true;
    } else if (this.data.buttons === ButtonsDialog.oknocancel) {
        this.buttonsOkNoCancel = true;
    } else if (this.data.buttons === ButtonsDialog.cancel) {
        this.buttonsCancel = true;
    }


    if (this.data.type === TypeDialog.success) {
       this.typeSuccess = true;
    } else if (this.data.type === TypeDialog.warn) {
       this.typeWarn = true;
    } else if (this.data.type === TypeDialog.confirm) {
       this.typeConfirm = true;
    } else if (this.data.type === TypeDialog.information) {
       this.typeInformation = true;
    }
  }

  onClose(opcion: number) {
    this.dialogRef.close(opcion);
  }


}
